import React from "react";
import styles from "../../../../styles/header-field.module.css";

function ComposerHeaderField(props: {
  label: string;
  children: React.ReactElement;
}) {
  const { label, children } = props;
  return (
    <div className={styles.composerHeaderField}>
      <span className={styles.composerHeaderFieldLabel}>{label}</span>
      {children}
    </div>
  );
}

export default ComposerHeaderField;
